import { ProductGroup } from '@/gql/graphql';
import { useUiStore } from '@/store/ui.store';
import { useAccount, useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { handleFilterSearch, sortProductGroupsByUpdatedAt } from './use-product-groups.hook.core';

type ProductGroupsHook = {
  loading: boolean;
  productGroups: ProductGroup[];
  search: string;
  filter: string;
  pageView: 'grid' | 'table';
  setPageView: (view: 'grid' | 'table') => void;
  handleFilterChange: (filter: string) => void;
  handleSearchChange: (search: string) => void;
};

type ProductGroupsHookProps = {
  initialProductGroups?: ProductGroup[];
};

export const useProductGroups = ({ initialProductGroups }: ProductGroupsHookProps): ProductGroupsHook => {
  const { productGroupsPageFilter, setProductGroupsPageFilter, productGroupsPageView, setProductGroupsPageView } =
    useUiStore((state) => state);

  const [loading, setLoading] = useState(true);
  const [productGroups, setProductGroups] = useState([] as ProductGroup[]);

  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState(productGroupsPageFilter);

  const { accounts } = useMsal();
  const account = useAccount(accounts[0]);

  useEffect(() => {
    if (!initialProductGroups) return;
    if (!account) return;
    const sorted = sortProductGroupsByUpdatedAt(initialProductGroups);
    setProductGroups(handleFilterSearch(sorted, search, filter, account));
    setLoading(false);
  }, [initialProductGroups]);

  useEffect(() => {
    if (!initialProductGroups) return;
    if (!account) return;
    const sorted = sortProductGroupsByUpdatedAt(initialProductGroups);
    setProductGroups(handleFilterSearch(sorted, search, filter, account));
  }, [search, filter]);

  const handleFilterChange = (filter: string) => {
    const selectedFilter = filter as 'ALL' | 'MINE';
    setFilter(selectedFilter);
    setProductGroupsPageFilter(selectedFilter);
  };

  const handleSearchChange = (search: string) => {
    setSearch(search);
  };

  return {
    loading,
    productGroups,
    search,
    filter,
    pageView: productGroupsPageView,
    setPageView: setProductGroupsPageView,
    handleFilterChange,
    handleSearchChange,
  };
};
